/**
 * Base Payment Calculator class
 */
class PaymentCalculator {
  constructor({
    price = 0,
    tradein = 0,
    tax = 13,
    down = 0,
    rate = 0
  } = {}) {
    this.price = price;
    this.tradein = tradein;
    this.tax = tax;
    this.balance = 0;
    this.down = down;
    this.rate = rate;
    this.payments = {
      'weekly': 0,
      'biweekly': 0,
      'monthly': 0
    };
    this.totalLoanAmount = 0;
  }

  calculatePayments() {}

  calculateBalance() {}

  calculate() {}

}

export default PaymentCalculator;
//# sourceMappingURL=PaymentCalculator.js.map